import {ImageEffectType} from "vtom-api-typescript-client";

export class ImageEffectTypes {
    static toLabelCode(value: ImageEffectType): string {
        return 'imageprocessing.effect.type.' + value.toLowerCase();
    }
}
